import { PropertyType } from '@/models/property.model';

export enum PricesEndpoints {
  ROOT = '/prices',
  DOCUMENTS = '/documents',
  SETTLEMENT = '/settlement',
  APPRAISER = '/appraiser',
  PHOTO_SHOOTING = '/photoshooting',
}

export const staticPriceEndpoints = {
  GET_APPRAISER_PRICES: `${PricesEndpoints.ROOT}${PricesEndpoints.APPRAISER}`,
  UPDATE_APPRAISER_PRICES: `${PricesEndpoints.ROOT}${PricesEndpoints.APPRAISER}`,
  UPDATE_SETTLEMENT_PRICES: `${PricesEndpoints.ROOT}${PricesEndpoints.SETTLEMENT}`,
  CREATE_APPRAISER_PRICES: `${PricesEndpoints.ROOT}${PricesEndpoints.APPRAISER}`,

  GET_PHOTO_SHOOTING_PRICES: `${PricesEndpoints.ROOT}${PricesEndpoints.PHOTO_SHOOTING}`,
  CREATE_PHOTO_SHOOTING_PRICE: `${PricesEndpoints.ROOT}${PricesEndpoints.PHOTO_SHOOTING}`,

  GET_DOCUMENTS_PRICE: `${PricesEndpoints.ROOT}${PricesEndpoints.DOCUMENTS}`,
  UPDATE_DOCUMENTS_PRICE: `${PricesEndpoints.ROOT}${PricesEndpoints.DOCUMENTS}`,

  GET_SETTLEMENT_PRICE: `${PricesEndpoints.ROOT}${PricesEndpoints.SETTLEMENT}`,
  UPDATE_SETTLEMENT_PRICE: `${PricesEndpoints.ROOT}${PricesEndpoints.SETTLEMENT}`,
};

export const getPricesEndpoints = ({ id }: { id: string }) => ({
  UPDATE_PHOTO_SHOOTING_PRICE: `${PricesEndpoints.ROOT}${PricesEndpoints.PHOTO_SHOOTING}/${id}`,
  DELETE_PHOTO_SHOOTING_PRICE: `${PricesEndpoints.ROOT}${PricesEndpoints.PHOTO_SHOOTING}/${id}`,
  UPDATE_APPRAISER_PRICE: `${PricesEndpoints.ROOT}${PricesEndpoints.APPRAISER}/${id}`,
  DELETE_APPRAISER_PRICE: `${PricesEndpoints.ROOT}${PricesEndpoints.APPRAISER}/${id}`,
});

export interface IPrice {
  price: number;
}

export enum AreaSizes {
  small = 1,
  medium = 101,
  large = 151,
}

export interface IAppraiserPrice extends IPrice {
  from_area: AreaSizes;
  PK: string;
  name_en: string;
  name_no: string;
  description_en: string;
  description_no: string;
  property_type: PropertyType;
  to_area: number | null;
}

export interface IPhotoShootingPrice extends IPrice {
  PK: string;
  name_no: string;
  name_en: string;
  description_en: string;
  description_no: string;
  property_type: PropertyType;
  from_area: number;
  to_area: number | null;
}
export interface ISettlementData {
  PK: string;
  name_no: string;
  name_en: string;
  description_en: string;
  description_no: string;
}

// ----------------- DTOs ----------------

export interface IBaseUpdatePriceDTO {
  price: number;
}

export interface IUpdateAppraiserPriceDTO extends IBaseUpdatePriceDTO {
  from_area: AreaSizes;
}

export interface IUpdatePhotoShootingPriceDTO extends Omit<IPhotoShootingPrice, 'PK'> {
  id: string;
}

export interface IUpdateSettlementDataDTO {
  name_no: string;
  name_en: string;
  description_en: string;
  description_no: string;
}

export type TCreatePhotoShootingPriceDTO = Omit<IPhotoShootingPrice, 'PK'>;

export type IAppraiserPriceDTO = Omit<IAppraiserPrice, 'PK'>;

// ------------ Responses --------------

export type TGetPriceBaseResponse = IPrice;

export type TGetAppraiserPriceResponse = IAppraiserPrice[];

export type TUpdateAppraiserPriceResponse = IAppraiserPrice;

export type TUpdateSettlementDataResponse = ISettlementData;

export type TGetPhotoShootingPriceResponse = IPhotoShootingPrice[];

export type TUpdatePhotoShootingPriceResponse = IPhotoShootingPrice;
